import { render, staticRenderFns } from "./ProtectedIndex.vue?vue&type=template&id=35dd907f&"
import script from "./ProtectedIndex.vue?vue&type=script&lang=js&"
export * from "./ProtectedIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports